module.exports = __webpack_public_path__ + "static/img/fish21.f7b25c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish21.png
// module id = NZmt
// module chunks = 0